import React from 'react';
// import react portal
import { createPortal } from 'react-dom';
import styled from 'styled-components';

function LightBox({ isOpen, image, onClose}) {
    if (!image) return null;
    return (
        <StyledLightBox className="js-lightbox" >
            <div className="mask" onClick={onClose}></div>
            <button className="close" onClick={onClose}>Close</button>
            <img src={`${image.startsWith("/") ? "" : "/"}${image}`} alt="" />
        </StyledLightBox>
    )
}

const StyledLightBox = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1000;

    top: 0;
    left: 0;

    .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    button {
        position: absolute;
        top: 20px;
        right: 20px;

        color: #fff;

        padding: 16px;
        font-size: 24px;
    }


    img {
        // absolute center
        position: absolute;
        left: 50%;
        top: 10vh;
        transform: translate(-50%, 0);

        max-height: 80vh;
        max-width: calc(100vw - 120px);
        object-fit: contain;

        @media (max-width: 768px) {
            top: 50%;
            transform: translate(-50%, -50%);
            max-width: calc(100vw - 40px);
        }
    }
`;

export default LightBox;